namespace AgerLMS {
    export enum QuestionChoices {
        ChoiceA = 0,
        ChoiceB = 1,
        ChoiceC = 2,
        ChoiceD = 3,
        ChoiceE = 4
    }
    Serenity.Decorators.registerEnumType(QuestionChoices, 'AgerLMS.QuestionChoices');
}
